module.exports = require('./helpers/bundle-url').getBundleURL('es2gC') + "logo-dark.eefe0b7f.svg";